import { createSlice, createSelector, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { addDays } from "date-fns";
import { PRICELIMIT } from "./config";
import { offerSortOptions, views } from "./utils";
// ✅ FIXED: Removed unused import that caused module initialization issues
// import { fetchRegionGroups } from "./propertiesSlice";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

const initialState = {
  selectedDestination: [],
  queryid: "",

  northEast: null,
  southWest: null,
  price: PRICELIMIT,
  adults: { value: "2", label: "2 Erwachsene" },
  children: { value: "0", label: "kein Kind" },
  durationkind: { value: "Trip", label: "Reisedauer" },
  childrenages: [
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
    { value: "0", label: "Alter" },
  ],
  activeMode: "PAC",
  stations: [],
  mid: "",
  multiroomdivider: 1,
  roomallocation: null,
  boardType: [],
  roomType: [],
  hotelAttribute: [],
  roomAttribute: [],
  roomView: [],
  priceChartDates: { outbound: null, from: null, until: null },
  desiredHotels: [],
  tourOperators: [],
  couponcode: "",
  outbounddate: "",
  outboundtime: "0-23",
  inbounddate: "",
  inboundtime: "0-23",
  travelDate: {
    from: addDays(new Date().setHours(0, 0, 0, 0), 7)
      .toISOString()
      .split("T")[0],
    until: addDays(new Date().setHours(0, 0, 0, 0), 37)
      .toISOString()
      .split("T")[0],
  },
  duration: { value: "7", label: "1 Woche" },
  durationDelta: null,
  freecancellation: false,
  addablecancellation: false,
  reservationoperatorsonly: false,
  freerebook: false,
  directflight: false,
  lowcost: false,
  linie: false,
  maxstops: -1,
  oneway: true,
  nofrill: false,
  fsciata: true,
  fscnego: true,
  fscconso: false,
  fsccorp: false,
  holidaycheck: 0,
  firstclass: false,
  businessclass: false,
  economyclass: true,
  baggageonly: true,
  gabelflug: false,
  gabelSegments: [
    { departure: null, destination: null, date: "" },
    { departure: null, destination: null, date: "" },
  ],
  verifiedfares: true,
  charter: false,
  transferincluded: false,
  railandfly: false,
  rentalcar: false,
  operatingbrand: [],
  destinationStations: [],
  selectedMarketingActions: [],
  specialRoomType: [],
  sorting: offerSortOptions[0],
  ratingcount: "0",
  recommendationrate: "0",
  category: "",
  searchRegions: undefined,
  searchAirports: undefined,
  searchDate: undefined,
  searchPersons: undefined,
  preferredCategory: "",
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    resetFilter: (state, action) => {
      //console.log(action.payload);
      if (action.payload === "mobile") {
        state.price = PRICELIMIT;
        state.recommendationrate = "0";
        state.category = "";
        state.ratingcount = "0";
        state.multiroomdivider = 1;
        state.roomallocation = null;
        state.hotelAttribute = [];
        state.specialRoomType = [];
        state.selectedMarketingActions = [];
        state.freecancellation = false;
        state.addablecancellation = false;
        state.freerebook = false;
        state.addablecancellation = false;
        state.reservationoperatorsonly = false;
        state.roomView = [];
        state.tourOperators = [];
        state.transferincluded = false;
        state.railandfly = false;
        state.rentalcar = false;
        state.operatingbrand = [];
        state.outboundtime = "0-23";
        state.inboundtime = "0-23";
        state.boardType = [];
        state.roomType = [];
        state.directflight = false;
        state.maxstops = 1;
        state.oneway = true;
        state.nofrill = false;
        state.fsciata = true;
        state.fscnego = true;
        state.fscconso = false;
        state.fsccorp = false;
        state.firstclass = false;
        state.businessclass = false;
        state.economyclass = true;
        state.baggageonly = true;
        state.verifiedfares = true;
        state.destinationStations = [];
        state.couponcode = "";
        state.lowcost = false;
        state.linie = false;
        state.charter = false;
        state.operatingbrand = [];
        return;
      }
      if (action.payload === views.offerview) {
        state.price = PRICELIMIT;
        state.recommendationrate = "0";
        state.multiroomdivider = 1;
        state.roomallocation = null;
        state.category = "";
        state.ratingcount = "0";
        state.hotelAttribute = [];
        state.specialRoomType = [];
        state.selectedMarketingActions = [];
        state.freecancellation = false;
        state.addablecancellation = false;
        state.freerebook = false;
        state.addablecancellation = false;
        state.reservationoperatorsonly = false;
        state.roomView = [];
        state.tourOperators = [];
        state.directflight = false;
        state.maxstops = 1;
        state.oneway = true;
        state.nofrill = false;
        state.fsciata = true;
        state.fscnego = true;
        state.fscconso = false;
        state.fsccorp = false;

        state.firstclass = false;
        state.businessclass = false;
        state.economyclass = true;
        state.baggageonly = true;
        state.verifiedfares = true;
        state.destinationStations = [];
        state.couponcode = "";
        state.transferincluded = false;
        state.railandfly = false;
        state.rentalcar = false;
        state.operatingbrand = [];
        state.outboundtime = "0-23";
        state.inboundtime = "0-23";
        state.boardType = [];
        state.roomType = [];
      }
      if (action.payload === views.hotelclassicview) {
        state.price = PRICELIMIT;
        state.recommendationrate = "0";
        state.category = "";
        state.ratingcount = "0";
        state.multiroomdivider = 1;
        state.roomallocation = null;
        state.hotelAttribute = [];
        state.specialRoomType = [];
        state.selectedMarketingActions = [];
        state.freecancellation = false;
        state.addablecancellation = false;
        state.freerebook = false;
        state.addablecancellation = false;
        state.reservationoperatorsonly = false;
        state.roomView = [];
        state.tourOperators = [];
        state.directflight = false;
        state.maxstops = 1;
        state.oneway = true;
        state.nofrill = false;
        state.fsciata = true;
        state.fscnego = true;
        state.fscconso = false;
        state.fsccorp = false;

        state.firstclass = false;
        state.businessclass = false;
        state.economyclass = true;
        state.baggageonly = true;
        state.verifiedfares = true;
        state.destinationStations = [];
        state.couponcode = "";
        state.transferincluded = false;
        state.railandfly = false;
        state.rentalcar = false;
        state.operatingbrand = [];
        state.outboundtime = "0-23";
        state.inboundtime = "0-23";
        state.boardType = [];
        state.roomType = [];
      }
      if (action.payload === views.hotelcrossview) {
        state.price = PRICELIMIT;
        state.recommendationrate = "0";
        state.category = "";
        state.ratingcount = "0";
        state.multiroomdivider = 1;
        state.roomallocation = null;
        state.hotelAttribute = [];
        state.specialRoomType = [];
        state.selectedMarketingActions = [];
        state.freecancellation = false;
        state.addablecancellation = false;
        state.freerebook = false;
        state.addablecancellation = false;
        state.reservationoperatorsonly = false;
        state.roomView = [];
        state.tourOperators = [];
        state.directflight = false;
        state.maxstops = 1;
        state.oneway = true;
        state.nofrill = false;
        state.fsciata = true;
        state.fscnego = true;
        state.fscconso = false;
        state.fsccorp = false;

        state.firstclass = false;
        state.businessclass = false;
        state.economyclass = true;
        state.baggageonly = true;
        state.verifiedfares = true;
        state.destinationStations = [];
        state.couponcode = "";
        state.transferincluded = false;
        state.railandfly = false;
        state.rentalcar = false;
        state.operatingbrand = [];
        state.outboundtime = "0-23";
        state.inboundtime = "0-23";
        state.boardType = [];
        state.roomType = [];
      }
      if (action.payload === views.searchview) {
        state.price = PRICELIMIT;
        state.recommendationrate = "0";
        state.category = "";
        state.ratingcount = "0";
        state.multiroomdivider = 1;
        state.roomallocation = null;
        state.hotelAttribute = [];
        state.specialRoomType = [];
        state.selectedMarketingActions = [];
        state.freecancellation = false;
        state.addablecancellation = false;
        state.freerebook = false;
        state.addablecancellation = false;
        state.reservationoperatorsonly = false;
        state.roomView = [];
        state.tourOperators = [];
        state.directflight = false;
        state.maxstops = 1;
        state.oneway = true;
        state.nofrill = false;
        state.fsciata = true;
        state.fscnego = true;
        state.fscconso = false;
        state.fsccorp = false;

        state.firstclass = false;
        state.businessclass = false;
        state.economyclass = true;
        state.baggageonly = true;
        state.verifiedfares = true;
        state.destinationStations = [];
        state.couponcode = "";
        state.transferincluded = false;
        state.railandfly = false;
        state.rentalcar = false;
        state.operatingbrand = [];
        state.outboundtime = "0-23";
        state.inboundtime = "0-23";
        state.boardType = [];
        state.roomType = [];
      }
    },

    setSearchRegions: (state, action) => {
      state.searchRegions = action.payload;
    },
    resetSearch: (state, action) => {
      state.selectedDestination = [];
      state.adults = { value: "2", label: "2 Erwachsene" };
      state.children = { value: "0", label: "kein Kind" };
      state.durationkind = {
        value: "Trip",
        label: "Reisedauer",
      };
      state.childrenages = [
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
        { value: "0", label: "Alter" },
      ];
      state.directflight = false;
      state.maxstops = 1;
      state.oneway = true;
      state.nofrill = false;
      state.fsciata = true;
      state.fscnego = true;
      state.fscconso = false;
      state.fsccorp = false;

      state.firstclass = false;
      state.businessclass = false;
      state.economyclass = true;
      state.baggageonly = true;
      state.verifiedfares = true;
      state.ratingcount = "0";
      state.recommendationrate = "0";
      state.category = "";
      state.couponcode = "";
      state.stations = [];
      state.duration = { value: "7", label: "1 Woche" };
      state.durationDelta = null;
      state.travelDate = {
        from: JSON.stringify(addDays(new Date(), 7)),
        to: JSON.stringify(addDays(new Date(), 37)),
      };
    },

    setMid: (state, action) => {
      state.mid = action.payload;
    },

    setSearchOption: (state, action) => {
      state[action.payload.property] = action.payload.data;
    },

    removeSearchOption: (state, action) => {
      state[action.payload.property] = state[action.payload.property].filter((e) => e != action.payload.data);
    },
    toggleSearchOption: (state, action) => {
      const key = action.payload.property;
      const value = action.payload.data;
      const arr = state[key] || [];

      if (arr.includes(value)) {
        state[key] = arr.filter((e) => e !== value);
      } else {
        state[key] = [...arr, value];
      }
    },
    setSearchOptions: (state, action) => {
      let keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        state[keys[i]] = action.payload[keys[i]];
      }
    },
    setSelectedMarketingActions: (state, action) => {
      state.selectedMarketingActions = action.payload;
    },
    setSpecialRoomType: (state, action) => {
      state.specialRoomType = action.payload;
    },

    setSelectedDestination: (state, action) => {
      state.selectedDestination = action.payload;
    },
    setNorthEast: (state, action) => {
      state.northEast = action.payload;
    },
    setSouthWest: (state, action) => {
      state.southWest = action.payload;
    },
    setActiveMode: (state, action) => {
      state.activeMode = action.payload;
    },
    setQueryid: (state, action) => {
      state.queryid = action.payload;
    },
    setOutbounddate: (state, action) => {
      state.outbounddate = action.payload;
    },
    setInbounddate: (state, action) => {
      state.inbounddate = action.payload;
    },
    setPreferredCategory: (state, action) => {
      state.preferredCategory = action.payload;
    },
  },
});

// FIXED: Input selectors must return stable references, result function creates the object
export const selectSearch = createSelector(
  (state) => state.search.selectedDestination,
  (state) => state.search.adults,
  (state) => state.search.children,
  (state) => state.search.multiroomdivider,
  (state) => state.search.childrenages,
  (state) => state.search.stations,
  (state) => state.search.boardType,
  (state) => state.search.roomType,
  (state) => state.search.roomView,
  (state) => state.search.priceSelect,
  (state) => state.search.price,
  (state) => state.search.hotelAttribute,
  (state) => state.search.outboundtime,
  (state) => state.search.inboundtime,
  (state) => state.search.travelDate,
  (state) => state.search.duration,
  (state) => state.search.freecancellation,
  (state) => state.search.destinationStations,
  (state) => state.search.directflight,
  (state) => state.search.transferincluded,
  (state) => state.search.recommendationrate,
  (state) => state.search.tourOperators,
  (state) => state.search.railandfly,
  (state) => state.search.rentalcar,
  (state) => state.search.sorting,
  (state) => state.search.operatingbrand,
  (state) => state.search.ratingcount,
  (state) => state.search.durationkind,
  (state) => state.search.category,
  (state) => state.search.couponcode,
  (state) => state.search.freerebook,
  (state) => state.search.addablecancellation,
  (state) => state.search.roomallocation,
  (
    selectedDestination,
    adults,
    children,
    multiroomdivider,
    childrenages,
    stations,
    boardType,
    roomType,
    roomView,
    priceSelect,
    price,
    hotelAttribute,
    outboundtime,
    inboundtime,
    travelDate,
    duration,
    freecancellation,
    destinationStations,
    directflight,
    transferincluded,
    recommendationrate,
    tourOperators,
    railandfly,
    rentalcar,
    sorting,
    operatingbrand,
    ratingcount,
    durationkind,
    category,
    couponcode,
    freerebook,
    addablecancellation,
    roomallocation,
  ) => ({
    selectedDestination,
    adults,
    children,
    multiroomdivider,
    childrenages,
    stations,
    boardType,
    roomType,
    roomView,
    priceSelect,
    price,
    hotelAttribute,
    outboundtime,
    inboundtime,
    travelDate,
    duration,
    freecancellation,
    destinationStations,
    directflight,
    transferincluded,
    recommendationrate,
    tourOperators,
    railandfly,
    rentalcar,
    sorting,
    operatingbrand,
    ratingcount,
    durationkind,
    category,
    couponcode,
    freerebook,
    addablecancellation,
    roomallocation,
  }),
);

// FIXED: Input selectors should return stable references
export const selectSearchFilters = createSelector(
  (state) => state.search.searchRegions,
  (state) => state.search.searchAirports,
  (state) => state.search.searchDate,
  (state) => state.search.searchPersons,
  (searchRegions, searchAirports, searchDate, searchPersons) => ({
    searchRegions,
    searchAirports,
    searchDate,
    searchPersons,
  }),
);

// ✅ FIXED: For simple pass-through, don't use createSelector - use a regular selector function
// createSelector with identity function triggers warnings and provides no memoization benefit
export const completeSearch = (state) => state.search;
export const {
  setSearchOption,
  removeSearchOption,
  toggleSearchOption,

  setSelectedDestination,
  setNorthEast,
  setSouthWest,
  setQueryid,
  setActiveMode,
  setMid,
  setOutbounddate,
  setInbounddate,

  setSelectedMarketingActions,
  setSpecialRoomType,
  setSearchOptions,
  resetFilter,
  resetSearch,
  setPreferredCategory,
} = searchSlice.actions;

export default searchSlice.reducer;
